<ng-container>
  <div class="settings-container p-4 text-primary font-size-small">
    <div class="row justify-content-between">
      <h5>{{ 'NOTIFICATION.APPLICATION_NEW_VERSION_TITLE' | translate }}</h5>
      <i 
        data-testid="new-application-version-popup-close-button"
        (click)="confirm()" 
        style="cursor: pointer;" 
        class="close-button far fa-times ml-2">
      </i>
    </div>
    <hr>
    <div class="row">
      <div class="col-12">
        <p class="font-size-small p-0">
          {{ 'NOTIFICATION.APPLICATION_NEW_VERSION_TEXT' | translate }}
        </p>
      </div>
    </div>

    <div class="row mt-3 mb-1 justify-content-end align-items-center">
      <lib-button
        data-testid="new-application-version-popup-confirm-button"
        [color]="'accent'"
        [width]="100"
        [label]="'Confirm'"
        [height]="32"
        [size]="'custom'"
        (click)="confirm()">
      </lib-button>
    </div>
  </div>
</ng-container>
